<template>
  <page-outline :title="$t('account_tb.account_tb_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" sm="3" md="2" xl="1">
            <back-button></back-button>
          </b-col>
          <b-col cols="4" sm="3" md="2" xl="1" @click="refresh">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>


        <spinner v-if="activateSpinnerBooks"></spinner>
        <template v-else-if="Books">
          <div>
            <form-accordion :title="$t('account_tb.users')" :isTitleUpperCase="false">
              <table class="table table-striped my-5" v-if="AccountTB.Users && AccountTB.Users.length">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('account_tb.login') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_last_session') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_creation') }}
                  </th>
                </tr>
                <tr v-for="user in AccountTB.Users" :key="user.IdUserAccount">
                  <td class="text-center w-25">
                    <div>{{ user.Login }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(user.DateLastSession) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(user.DateCreation) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_users') }}
                    </span>
              </div>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('account_tb.booking')" :isTitleUpperCase="false">
              <table class="table table-striped my-5" v-if="Books && Books.length">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_start') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_end') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.session_number') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.status.date') }}
                  </th>
                </tr>
                <tr v-for="(books, index) in Books" :key="index">
                  <td class="text-center w-25">
                    <div>{{ getDate(books.DateStart) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(books.DateEnd) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ books.SessionNumber }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getBookStatus(books.DateStart, books.DateEnd) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_books') }}
                    </span>
              </div>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('account_tb.test_validation')" :isTitleUpperCase="false">
              <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;">
                <b-button
                    class="responsive-button"
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :variant="tabName === index ? 'primary' : 'secondary'"
                    @click="tabName = index">
                  {{ $t(tab.translationKey) }}
                </b-button>
              </b-button-group>

              <b-tabs v-model="tabName" @input="onTabChange" nav-class="d-none">
                <b-tab :title="$t('account_tb.all')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataAll" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.all") }}
                      </h3>
                      <pie-chart
                          ref="pieChartAll"
                          :chart-data="pieChartDataAll"
                          :options="chartOptionsAll">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab :title="$t('account_tb.responder')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataRes" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.responder") }}
                      </h3>
                      <pie-chart
                          ref="pieChartRes"
                          :chart-data="pieChartDataRes"
                          :options="chartOptionsRes">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab :title="$t('account_tb.requester')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataReq" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.requester") }}
                      </h3>
                      <pie-chart
                          ref="pieChartReq"
                          :chart-data="pieChartDataReq"
                          :options="chartOptionsReq">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
              </b-tabs>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import {errorMessageAlert} from "@/helpers/alert"
import moment from "moment-timezone"
import alpha2Country from "../../data/alpha2Country.json"
import {Pie} from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: 'AccountTBDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, this.options)
      }
    }
  },
  computed: {
    listTitle () {
      return this.$t('tracking.tracks_details')
    }
  },
  props: ['id', 'type'],
  data () {
    return {
      timezone: '+00:00',
      activateSpinnerTest: false,
      activateSpinner: false,
      activateSpinnerBooks: false,
      countries: alpha2Country.countries.reverse(),
      returnUrl: '',
      tabName: 0,
      tabs: [
        { translationKey: 'account_tb.all' },
        { translationKey: 'account_tb.responder' },
        { translationKey: 'account_tb.requester' },
      ],
      chartOptionsAll: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsReq: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsRes: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      pieChartDataRes: null,
      pieChartDataAll: null,
      pieChartDataReq: null,
      AccountTB: [],
      Books: []
    }
  },
  watch: {
    tabName(newVal) {
      this.$nextTick(() => {
        this.onTabChange(newVal)
      })
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    
    this.activateSpinnerTest = true
    this.activateSpinnerBooks = true
    this.idAccountTBBulk = this.$route.query.idAccountTBBulk
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur'
    })

    this.$engine.firstOn().settings.set({msgDirection: this.direction})
    this.fetchAccountTB()
    this.fetchTestTB()
    this.fetchBookingTB()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    onTabChange(index) {
      const charts = [
        {
          ref: this.$refs.pieChartAll,
          data: this.pieChartDataAll,
          options: this.chartOptionsAll
        },
        {
          ref: this.$refs.pieChartRes,
          data: this.pieChartDataRes,
          options: this.chartOptionsRes
        },
        {
          ref: this.$refs.pieChartReq,
          data: this.pieChartDataReq,
          options: this.chartOptionsReq
        }
      ]

      const chart = charts[index]

      if (chart && chart.ref) {
        chart.ref.renderChart(chart.data, chart.options)
      }

      // Gérer le spinner si nécessaire
      // this.$nextTick(() => {
      //   this.activateSpinner = false
      // })
    },
    getBookStatus(DateStart, DateEnd) {
      const now = new Date();

      if (DateEnd < now) {
        return this.$t("account_tb.status.past")
      } else if (DateStart > now) {
        return this.$t("account_tb.status.future")
      } else {
        return this.$t("account_tb.status.current")
      }
    },
    getDate(date){
      if (!date) return '-';

      // Si la date ne contient pas un offset explicite (+00:00, +04:00, etc.) ou 'Z', on suppose qu'elle est en UTC
      const hasTimezone = /([+-]\d{2}:\d{2}|Z)$/.test(date);
      const isoWithTZ = hasTimezone ? date : date + 'Z';

      return moment(isoWithTZ).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss');
    },
    refresh(){
      this.fetchAccountTB()
      this.fetchTestTB()
      this.fetchBookingTB()
    },
    defineReturnURL() {
      let that = this
      let type = parseInt(this.type, 10)
      if (!isNaN(type) && this.type == type){
        this.returnUrl =  '/tracking/BULKDETAILS/'+ this.type
      }else{
        if (this.idAccountTBBulk !== undefined) {
          this.returnUrl = '/trackingbulk/' + this.idAccountTBBulk
        }
        else {
          this.returnUrl =  '/tracking/'+ this.type+'/NULL'
        }
      }
    },
    fetchAccountTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.firstOn().accountTB.getAccountTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        if (resp.data && resp.data.accounts && resp.data.accounts.length) {
          that.AccountTB = resp.data.accounts[0]
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    generatePieChartDataStatus(data) {
      let types = ['all', 'req', 'resp'];
      let pieChartData = {};

      types.forEach((type) => {
        let filteredResponses = data.filter((item) => {
          if (type === 'all') {
            return item.Type === 'resp' || item.Type === 'req';
          }
          return item.Type === type;
        });

        let statusCounts = {
          OK: 0,
          KO: 0,
          NULL: 0,
          RUN: 0,
          CONF_NOT_FOUND: 0,
        };

        filteredResponses.forEach((item) => {
          switch (item.Status) {
            case '2':
              statusCounts.OK++;
              break;
            case '0':
              statusCounts.KO++;
              break;
            case '1':
              if (type === 'req') statusCounts.RUN++;
              break;
            case '3':
              if (type === 'resp') statusCounts.CONF_NOT_FOUND++;
              break;
            default:
              statusCounts.NULL++;
              break;
          }
        });

        let labels = ['OK', 'KO', 'Null'];
        let dataValues = [statusCounts.OK, statusCounts.KO, statusCounts.NULL];
        let colors = [
          this.getCustomColor('OK', 0.8),
          this.getCustomColor('KO', 0.8),
          this.getCustomColor('NULL', 0.8),
        ];

        if (type === 'req') {
          labels.push('RUN');
          dataValues.push(statusCounts.RUN);
          colors.push(this.getCustomColor('RUN', 0.8));
        }

        if (type === 'resp') {
          labels.push('Conf introuvable');
          dataValues.push(statusCounts.CONF_NOT_FOUND);
          colors.push(this.getCustomColor('CONF_NOT_FOUND', 0.8));
        }

        pieChartData[type] = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: colors,
            },
          ],
        };
      });

      this.pieChartDataAll = pieChartData['all'];
      this.pieChartDataReq = pieChartData['req'];
      this.pieChartDataRes = pieChartData['resp'];

      this.$nextTick(() => {
        if (this.$refs.pieChartAll) {
          this.$refs.pieChartAll.renderChart(
              this.pieChartDataAll,
              this.chartOptionsAll
          );
        }
        if (this.$refs.pieChartReq) {
          this.$refs.pieChartReq.renderChart(
              this.pieChartDataReq,
              this.chartOptionsReq
          );
        }
        if (this.$refs.pieChartRes) {
          this.$refs.pieChartRes.renderChart(
              this.pieChartDataRes,
              this.chartOptionsRes
          );
        }
      });
    },
    fetchTestTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.firstOn().accountTB.getTestTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        this.generatePieChartDataStatus(resp.data.Tests)
        this.activateSpinnerTest = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },

    fetchBookingTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.firstOn().accountTB.getBookingTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}

        this.Books = resp.data.books


        that.activateSpinnerBooks = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'InTesting': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'RUN': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'OK': // Bleu clair
          r = 86;
          g = 180;
          b = 233;
          break;
        case 'connector 3': // Gris neutre
        case 'NoEnrollment': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'CONF_NOT_FOUND': // Vert turquoise clair
          r = 0;
          g = 158;
          b = 115;
          break;
        case 'Planned': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'KO': // Brun chaud
          r = 213;
          g = 94;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'AllTestOk': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NULL': // Rouge atténué
          r = 204;
          g = 0;
          b = 0;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>
